import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GetSnappyCampaignsQuery } from 'graphql.types';
import { getSnappyCampaigns } from 'settings/graphql/getSnappyCampaigns';

type SnappyCampaignOption = { label: string; value: string };

type SnappyCampaignsResponse = {
  loading: boolean;
  campaigns: SnappyCampaignOption[];
};

const defaultOption: SnappyCampaignOption = {
  label: '- Select Campaign -',
  value: '',
};

export function useSnappyCampaigns(): SnappyCampaignsResponse {
  const { data, loading } = useQuery<GetSnappyCampaignsQuery>(
    getSnappyCampaigns
  );

  const campaignsWithDefaultOption = useMemo(() => {
    const rawCampaigns = data?.snappyCampaigns || [];

    const dropdownCampaigns = rawCampaigns.map(campaign => ({
      value: campaign.extSnappyCampaignId,
      label: campaign.name,
    }));
    return [defaultOption, ...dropdownCampaigns];
  }, [data]);

  return {
    loading,
    campaigns: campaignsWithDefaultOption,
  };
}
